module.exports = __webpack_public_path__ + "img/csr_swiper_09_mobile.8c2ede4e.jpg";